import { Head } from "@inertiajs/react"
import { Container, Heading, Section } from "@radix-ui/themes"
import ManagershipsTable from "@/shared/admin/ManagershipsTable"
import { UserWithManagerships, ManageableForAdmin } from "@/types/shared"

interface Props {
  users: UserWithManagerships[]
  all_tracks: ManageableForAdmin[]
}

export default function AdminTrackManagersIndex({ users, all_tracks }: Props) {
  return (
    <div className="flex">
      <Head title="Track Managers - Admin" />
      <div className="grow">
        <Section>
          <Container size="4">
            <Heading size="7" mb="6">
              Track Manager Assignments
            </Heading>
            <ManagershipsTable
              users={users}
              assignable={all_tracks}
              endpoint="/admin/track_managers"
              paramKey="track_id"
              placeholder="Select a track..."
              emptyMessage="No tracks assigned"
            />
          </Container>
        </Section>
      </div>
    </div>
  )
}
